module.exports = __webpack_public_path__ + "static/media/dwolla-dark.ccae2767.svg";